// extracted by mini-css-extract-plugin
module.exports = {"Item":"Item_Item__Ly3py","Image":"Item_Image__170AW","Content":"Item_Content__3vKpl","slideUpBtn":"Item_slideUpBtn__2sWDw"};